import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IProgramFamily } from "@pbm/programs-families/contracts/program-family";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useProgramFamily(
  programCode: string,
  programFamilyCode: string
) {
  const { request } = usePbm2Url();
  return useQuery(
    `programFamily:${programCode}:${programFamilyCode}`,
    async () => {
      const {
        Rules_programFamilies: { edges },
      } = await request(
        gql`
          query ($programCode: String!, $programFamilyCode: String!) {
            Rules_programFamilies(
              first: 1
              programCode: $programCode
              filter: { code: [$programFamilyCode] }
            ) {
              edges {
                cursor
                node {
                  code
                  name
                  createdAt
                  updatedAt
                  deletedAt
                  effectiveSince
                  effectiveUntil
                  registrationPolicy {
                    id
                    description
                    requiresRegistration
                    requiresPrescription
                    createdAt
                  }
                }
              }
            }
          }
        `,
        { programCode, programFamilyCode }
      );
      const families = (edges || []).map(
        ({ node }: { node: IProgramFamily }) => node
      ) as IProgramFamily[];

      return families.shift();
    }
  );
}
